export default __webpack_public_path__ + "static/media/b03_c.d6486d47.png";